export default __webpack_public_path__ + "static/media/rocket.01b8951e.gif";